import { WebsocketEntityModificationMessage } from "@intelligems/ig-types/functions/meta/web-socket/experience";
import { QueryClient } from "@tanstack/react-query";

import {
  experienceKeys,
  personalizationKeys,
  scheduleKeys,
  setExperienceQueryData,
} from "@src/api/queryKeys";

export function updateEntityModificationCache(
  message: WebsocketEntityModificationMessage,
  queryClient: QueryClient
) {
  if (message.experience) {
    setExperienceQueryData(queryClient, message.experience);
    void queryClient.invalidateQueries({
      queryKey: scheduleKeys.one(message.experience.id),
    });
  } else if (message.experienceId) {
    void queryClient.invalidateQueries({
      queryKey: experienceKeys.one(message.experienceId),
    });
    void queryClient.invalidateQueries({
      queryKey: scheduleKeys.one(message.experienceId),
    });
  } else if (message.campaignId) {
    void queryClient.invalidateQueries({
      queryKey: personalizationKeys.one(message.campaignId),
    });
  }
}
